export default __webpack_public_path__ + "static/media/TriColorGoldPlated6mmBangles.c86b29f1.jpg";